export const HIGH_TASTE = 'Sativa'
export const admin_tg = 'bybob_b'